var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Mapping of torrent pieces to their respective availability in the torrent swarm. Used
 * by the torrent manager for implementing the rarest piece first selection strategy.
 */
var RarityMap = /*#__PURE__*/function () {
  "use strict";

  function RarityMap(torrent) {
    var _this = this;

    _classCallCheck(this, RarityMap);

    this._torrent = torrent;
    this._numPieces = torrent.pieces.length;
    this._pieces = new Array(this._numPieces);

    this._onWire = function (wire) {
      _this.recalculate();

      _this._initWire(wire);
    };

    this._onWireHave = function (index) {
      _this._pieces[index] += 1;
    };

    this._onWireBitfield = function () {
      _this.recalculate();
    };

    this._torrent.wires.forEach(function (wire) {
      _this._initWire(wire);
    });

    this._torrent.on('wire', this._onWire);

    this.recalculate();
  }
  /**
   * Get the index of the rarest piece. Optionally, pass a filter function to exclude
   * certain pieces (for instance, those that we already have).
   *
   * @param {function} pieceFilterFunc
   * @return {number} index of rarest piece, or -1
   */


  _createClass(RarityMap, [{
    key: "getRarestPiece",
    value: function getRarestPiece(pieceFilterFunc) {
      var candidates = [];
      var min = Infinity;

      for (var i = 0; i < this._numPieces; ++i) {
        if (pieceFilterFunc && !pieceFilterFunc(i)) continue;
        var availability = this._pieces[i];

        if (availability === min) {
          candidates.push(i);
        } else if (availability < min) {
          candidates = [i];
          min = availability;
        }
      }

      if (candidates.length) {
        // if there are multiple pieces with the same availability, choose one randomly
        return candidates[Math.random() * candidates.length | 0];
      } else {
        return -1;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this._torrent.removeListener('wire', this._onWire);

      this._torrent.wires.forEach(function (wire) {
        _this2._cleanupWireEvents(wire);
      });

      this._torrent = null;
      this._pieces = null;
      this._onWire = null;
      this._onWireHave = null;
      this._onWireBitfield = null;
    }
  }, {
    key: "_initWire",
    value: function _initWire(wire) {
      var _this3 = this;

      wire._onClose = function () {
        _this3._cleanupWireEvents(wire);

        for (var i = 0; i < _this3._numPieces; ++i) {
          _this3._pieces[i] -= wire.peerPieces.get(i);
        }
      };

      wire.on('have', this._onWireHave);
      wire.on('bitfield', this._onWireBitfield);
      wire.once('close', wire._onClose);
    }
    /**
     * Recalculates piece availability across all peers in the torrent.
     */

  }, {
    key: "recalculate",
    value: function recalculate() {
      this._pieces.fill(0);

      var _iterator = _createForOfIteratorHelper(this._torrent.wires),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var wire = _step.value;

          for (var i = 0; i < this._numPieces; ++i) {
            this._pieces[i] += wire.peerPieces.get(i);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_cleanupWireEvents",
    value: function _cleanupWireEvents(wire) {
      wire.removeListener('have', this._onWireHave);
      wire.removeListener('bitfield', this._onWireBitfield);
      if (wire._onClose) wire.removeListener('close', wire._onClose);
      wire._onClose = null;
    }
  }]);

  return RarityMap;
}();

module.exports = RarityMap;